// BL-1489 — registry entries for the clerk's shared bidder-message inbox
// (ADR 027 — Response Contract).
//
// GATED (BL-1833 PR 3a, ADR 062 — Access Grants): every verb needs
// clerking.manage and states its tenant as `tenant_id` — a thread spans
// auctions (one conversation per bidder per tenant, forever), so no record
// names it. The gate checks the stated tenant against membership.
//
// The grant is `lot.hammer` — the "clerk bundle", as on the bidders POST:
// every clerking.manage grant is a `lot.*` action until ADR 062 step 4 gives
// clerking its own resource, and adding a grant string would leave step 1.
import { responseType } from '@auctogon/core/api/registry';
import { defineAdminRoute } from './define-admin-route';
import type { AdminVerbSpec } from './define-admin-route';
// Type-only import (erased at build) — keeps the registry client-bundle-safe.
import type {
  ConversationInboxDto,
  ConversationReadClaimDto,
  ConversationReplyDto,
  ConversationThreadDto,
} from '../../schemas/responses/conversation';

const CLERK_MESSAGING_QUERY = {
  grant: 'lot.hammer',
  tenant: { from: 'input', field: 'tenant_id', in: 'query' },
} as const satisfies Pick<AdminVerbSpec, 'grant' | 'tenant'>;
const CLERK_MESSAGING_BODY = {
  grant: 'lot.hammer',
  tenant: { from: 'input', field: 'tenant_id', in: 'body' },
} as const satisfies Pick<AdminVerbSpec, 'grant' | 'tenant'>;

export const conversations = {
  index: defineAdminRoute({
    path: '/api/conversations',
    params: {},
    methods: {
      GET: {
        ...CLERK_MESSAGING_QUERY,
        response: responseType<ConversationInboxDto>(),
        query: { tenant_id: '', sort: '', cursor: '', limit: '' },
      },
    },
  }),
  id: {
    index: defineAdminRoute({
      path: '/api/conversations/:customerUserId',
      params: { customerUserId: '' },
      methods: {
        GET: {
          ...CLERK_MESSAGING_QUERY,
          response: responseType<ConversationThreadDto>(),
          query: { before: '', auction_id: '', limit: '' },
        },
        POST: { ...CLERK_MESSAGING_BODY, response: responseType<ConversationReplyDto>() },
      },
    }),
    read: defineAdminRoute({
      path: '/api/conversations/:customerUserId/read',
      params: { customerUserId: '' },
      methods: { POST: { ...CLERK_MESSAGING_BODY, response: responseType<ConversationReadClaimDto>() } },
    }),
  },
};
